module.exports = __webpack_public_path__ + "img/welcome-mockup.fa9a9493.png";